import { atom } from 'recoil';

export const description = atom({
  key: 'description',
  default: undefined,
});
